import React, { useRef, useState } from 'react';
import { Pagina } from '../../componentes/pagina';
import { usePdf } from '@mikecousins/react-pdf';

export default function Transparencia() {
    const [page, setPage] = useState(1);
    const [arquivo, setArquivo] = useState('./pdf/RELATORIO_TRANSPARENCIA_1_2025.pdf'); // Nome simplificado sem caracteres especiais
    const canvasRef = useRef(null);

    const mudarArquivo = (novoArquivo) => {
        setArquivo(novoArquivo);
        setPage(1); // Reinicia na página 1 ao trocar de relatório
    };

    const abrirPDF = (url) => {
        window.open(url, '_blank');
    };

    const { pdfDocument } = usePdf({
        file: arquivo,
        page,
        canvasRef,
    });

    return (
        <>
            

            {/* Página com o visualizador de PDF */}
            <Pagina titulo="Relatório de Transparência e Igualdade Salarial">

                {/* Seção para troca de relatórios */}
            <div className="troca-pdf">
                <button className="ui button" onClick={() => mudarArquivo('./pdf/Relatório de Transparência e Igualdade Salarial_Aval1°Sem2024.pdf')}>
                    1° Semestre 2024
                </button>
                <button className="ui button" onClick={() => mudarArquivo('./pdf/Relatório de Transparência e Igualdade Salarial_Aval2ºSem2024.pdf')}>
                    2° Semestre 2024
                </button>
                <button className="ui button" onClick={() => mudarArquivo('./pdf/RELATORIO_TRANSPARENCIA_1_2025.pdf')}>
                    1° Semestre 2025
                </button>
                <button className="ui button" onClick={() => mudarArquivo('./pdf/RelatorioIgualdadeSalarialLote_2025_2_AVAL MATRIZ.pdf')}>
                    2° Semestre 2025 Matriz
                </button>
                <button className="ui button" onClick={() => mudarArquivo('./pdf/RelatorioIgualdadeSalarialLote_2025_2_AVIAÇÃO.pdf')}>
                    2° Semestre 2025 Aviação
                </button>
                <button className="ui button" onClick={() => mudarArquivo('./pdf/RelatorioIgualdadeSalarialLote_2025_2_MARECHAL.pdf')}>
                    2° Semestre 2025 Marechal
                </button>
            </div>
            <div className="pdf" style={{ cursor: 'pointer' }} onClick={() => abrirPDF(arquivo)}>
                    {!pdfDocument ? (
                        <span>Carregando...</span>
                    ) : (
                        <canvas ref={canvasRef} />
                    )}
                
            </div>
                {/* Controles de navegação do PDF */}
                {pdfDocument && pdfDocument.numPages > 1 && (
                    <nav>
                        <button
                            className="ui button"
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                        >
                            Anterior
                        </button>
                        <button
                            className="ui button"
                            disabled={page === pdfDocument.numPages}
                            onClick={() => setPage(page + 1)}
                        >
                            Próximo
                        </button>
                        <button 
                            className="ui button" 
                            onClick={() => abrirPDF(arquivo)}
                        >
                            Expandir arquivo
                        </button>
                    </nav>
                )}
                
            </Pagina>
        </>
    );
}
